import { createFileRoute } from "@tanstack/react-router";
import { ScribePage } from "shared/components/global/Scribe/ScribePage";

/** @public */
export const Route = createFileRoute("/_auth/help/topics")({
    component: () => <ScribePage src="https://scribehow.com/page-embed/Topic_Management___ph3Gd9gRbuZ0QImxaEfCw" />,
});
